import React from "react";
import "./page.css";

const Datasets = () => {
    const title = (
        <>
            Datasets
        </>  
    );

    // !!! Place the .zip file in public/datasets
    const datasets = {
        "Campaign 6 — July 2024 [Not yet available]": [
            { name: "Soon...",  }, //url: "", downloadName: ""
        ],
        "Campaign 5 — March 2024 [Not yet available]": [
            { name: "Download CS_PoneyPot_Campaign_5.zip", url: "/datasets/exp5.zip", downloadName: "CS_PoneyPot_Campaign_5.zip" },
        ],
        "Campaign 4 — October 2023 [Not yet available]": [
            { name: "Download CS_PoneyPot_Campaign_4.zip", url: "/datasets/exp4.zip", downloadName: "CS_PoneyPot_Campaign_4.zip" },
        ],
    };

    const paraText = `Campaigns 1, 2, and 3 were trials.`;

 
    return (
        <div className="page">
            <div className="page-title">
                <h1>{title}</h1>
            </div>
            <br />
            <br />
            <br />

            {Object.keys(datasets).map((category, index) => (
                <div key={index}>
                    <div className="page-category">
                        <h2>{category}</h2>
                        <ul className="page-list">
                            {datasets[category].map((dataset, subIndex) => (
                                <li key={subIndex} className="page-item">
                                    <h3>
                                        <a  
                                            className="page-link" 
                                            href={dataset.url} 
                                            download={dataset.downloadName}
                                        >
                                            {dataset.name}
                                        </a>
                                    </h3>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <br />
                </div>
            ))}

            <div className="page-item">
                <p>{paraText}</p>
            </div>
            <br />
            <br />
        </div>
    );
};

export default Datasets;
